import { /* baseClient, */ authClient, API } from '../../utils/index'
import { uploadSingleFile } from '../files'

// Get all gpsDevices
export const getGpsDevices = () => {
	return authClient().get(`${API}/gpsDevice`)
}

// Semáforo de toda la flota: device + estado ok/warn/critical + conectado
export const getGpsDevicesStatus = () => {
	return authClient().get(`${API}/gpsDevice/status`)
}

// --- Comandos SMS (rescate remoto vía 1NCE) ---
export const getSmsActions = () => {
	return authClient().get(`${API}/gpsDevice/sms-actions`)
}

export const getSmsHistory = (id) => {
	return authClient().get(`${API}/gpsDevice/${id}/sms`)
}

export const sendSmsCommand = (id, body) => {
	return authClient().post(`${API}/gpsDevice/${id}/sms`, body)
}

// Get gpsDevice by id
export const getGpsDeviceById = (id) => {
	return authClient().get(`${API}/gpsDevice/${id}`)
}

// Delete gpsDevice
export const deleteGpsDevice = (id) => {
	return authClient().delete(`${API}/gpsDevice/${id}`)
}

// Create gpsDevice
export const postGpsDevice = async (gpsDevice) => {
	return authClient().post(`${API}/gpsDevice`, gpsDevice)
}

// Update gpsDevice
export const updateGpsDevice = async (id, gpsDevice) => {
	return authClient().put(`${API}/gpsDevice/${id}`, gpsDevice)
}

// ── Inventario (solo administración) ──────────────────────────────────────

/** Da de alta una caja entera pegando los IMEI, separados por lo que sea. */
export const altaEnLote = (codigos) => authClient().post(`${API}/gpsDevice/lote`, { codigos })

/** Entrega N aparatos de las existencias a un club, los más antiguos primero. */
export const entregarGpsDevices = (club, cuantos) =>
	authClient().post(`${API}/gpsDevice/entregar`, { club, cuantos })

/** Los devuelve a existencias. Sin `cuantos`, el pack entero. */
export const recogerGpsDevices = (club, cuantos) =>
	authClient().post(`${API}/gpsDevice/recoger`, { club, cuantos })

/**
 * Códigos de pegatina para los aparatos que no tengan.
 *
 * Sin `ids` se los pone a toda la flota a la que le falten; con `ids`, solo a
 * esos. Es idempotente: no pisa un código ya impreso.
 */
export const asignarCodigosPegatina = (ids) =>
	authClient().post(`${API}/gpsDevice/codigos-pegatina`, ids ? { ids } : {})
